<template>
    <v-container>
        <v-layout justify-end>
            <v-flex xs2 text-xs-right>
                <v-text-field label="Invocie no:" v-model="invNo" readonly  tabindex="-1"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout justify-end>
            <v-flex xs2>
                <v-text-field label="Date:" v-model="date"></v-text-field>
            </v-flex>
        </v-layout>
        <hr>
        <v-layout pt-2 pb-2 indigo lighten-4>
            <v-flex xs1 ml-1 mr-2><strong>No</strong></v-flex>
            <v-flex xs3 mr-3><strong>Model</strong></v-flex>
            <v-flex xs1 mr-2 pr-1 text-xs-center><strong>Frame</strong></v-flex>
            <v-flex xs1 mr-2 text-xs-center><strong>Front</strong></v-flex>
            <v-flex xs3 mr-3><strong>Quality control</strong></v-flex>
            <!-- <v-flex xs2 mr-2 text-xs-right><strong>Amount</strong></v-flex> -->
            <v-flex xs2></v-flex>
        </v-layout>
        <hr>
        <v-layout wrap v-for="(item,i) in detail" :key="i" collapse>
            <v-flex xs1 ml-1 mr-2>
                <v-text-field :value="i+1" readonly></v-text-field>
            </v-flex>
            <v-flex xs3 mr-2>
                <v-text-field v-model="item.Code" readonly></v-text-field>
            </v-flex>
            <v-flex xs1 mr-2>
                <v-text-field v-model="item.frame"></v-text-field>
            </v-flex>
            <v-flex xs1 mr-2>
                <v-text-field v-model="item.front"></v-text-field>
            </v-flex>
            <v-flex mr-2 v-if="!item.subProd">
                <v-text-field v-model="item.qc"></v-text-field>
            </v-flex>
            <v-layout v-for="(item,j) in item.subProd" :key="j">
                <v-flex xs1 ml-1 mr-2></v-flex>
                <v-flex xs3 mr-2>
                    <v-text-field v-model="item.subCode" readonly></v-text-field>
                </v-flex>
                <v-flex xs1 mr-2>
                    <v-text-field v-model="item.frame" readonly></v-text-field>
                </v-flex>
                <v-flex xs1 mr-2>
                    <v-text-field v-model="item.front" readonly></v-text-field>
                </v-flex>
                <v-flex mr-2>
                    <v-text-field v-model="item.qc" readonly></v-text-field>
                </v-flex>
            </v-layout>
        </v-layout>
        <hr>
    </v-container>
</template>
<script>
export default {
    data(){
        return{
            invNo: this.$route.query.invNo,
            date: this.$route.query.date,
            detail: JSON.parse(this.$route.query.detail),
        }
    },
    mounted(){
        setTimeout(() => {
            window.print()
            window.close()
        }, 1)
    }
}
</script>
<style scoped>
.collapse:nth-child(even){
    background-color: #dddddd;
}
table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  /* text-align: left; */
  padding: 0.5%;
  /* padding: 10px; */
}
.line{
    border-bottom: 1px solid gray;
    text-align: right;
    width: 100%;
}
</style>